const modelName = 'Attribute Sets';
const modelNameSingular = 'Attribute Sets';
const endpoint = '/attribute-sets';

const setup = {
    title: modelName,
    singular: modelNameSingular,
    model: modelName.replace(/\s+/g, '-').toLowerCase(),
    canDelete: true,
    canAddNew: true,
    canSearch: true,
    endpoint,
    accessor: 'id',
};

export default setup;
